<template>
  <section>
    <my-agreements-list v-if="agreements && agreements.length" :agreements="agreements"/>
    <div v-if="getUser && getUser.role !== 6">
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-12">
          <h6 class="ms-1 mb-5 mt-2 text-gray-700">Инструкция</h6>
          <div class="card-body d-flex flex-column flex-center bg-primary rounded p-8 mb-5">
            <div class="mb-2">
              <h1 class="fw-semibold text-white text-center lh-lg">
                Инструкция
                <span class="d-block fs-6">по использованию системы eagent</span>
              </h1>
              <div class="py-10 text-center">
                <img :src="require('@/assets/media/svg/illustrations/easy/2.svg')" class="theme-light-show w-200px" alt="">
                <img :src="require('@/assets/media/svg/illustrations/easy/2-dark.svg')" class="theme-dark-show w-200px" alt="">
              </div>
            </div>
            <div class="text-center w-100 mb-1">
              <router-link :to="{ name: 'Instruction' }" class="btn btn-sm d-block btn-light text-primary fw-bolder">Посмотреть</router-link>
            </div>
          </div>
        </div>
        <div class="col-xl-8 col-lg-6 col-md-12">
          <h6 class="ms-1 mb-5 mt-2 text-gray-700">Полис / Договор</h6>
          <div class="row">
            <div class="col-xl-6 col-lg-12 col-md-12">
              <div class="mb-3">
                <div class="rounded border p-6 bg-white info-panel">
                  <h3 class="text-gray-800 fs-5">ОГПО ВТС</h3>
                  <div class="text-gray-600 py-3 pb-6">
                    Обязательное страхование гражданско-правовой ответственности владельцев транспортных средств (Стандарт/ВВ/Транзит)
                  </div>
                  <router-link :to="{ name: 'Ogpo' }" type="button" class="btn-sm btn btn-light-success">
                    Оформить
                  </router-link>&nbsp;
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-12 col-md-12">
              <div class="mb-3">
                <div class="rounded border p-6 bg-white info-panel">
                  <h3 class="text-gray-800 fs-5">Имущество</h3>
                  <div class="text-gray-600 py-3 pb-6">
                    Добровольное страхование имущества заемщиков и лизингополучателей финансовых институтов от рисков и ущерба.
                  </div>
                  <router-link :to="{ name: 'Properties' }" type="button" class="btn-sm btn btn-light-success">
                    Оформить
                  </router-link>&nbsp;
                </div>
              </div>
            </div>
            <div class="col-xl-6 col-lg-12 col-md-12">
              <div class="mb-3">
                <div class="rounded border p-6 bg-white info-panel">
                  <h3 class="text-gray-800 fs-5">Каско</h3>
                  <div class="text-gray-600 py-3 pb-6">
                    Добровольное страхование автомобильного транспорта, являющегося залоговым обеспечением/предметом лизинга для ФЛ, ЮЛ, ИП, КХ.
                  </div>
                  <router-link :to="{ name: 'Casco' }" type="button" class="btn-sm btn btn-light-success">
                    Оформить
                  </router-link>&nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <h6 class="ms-1 mb-5 mt-2 text-gray-700">Функционал</h6>
        <div class="row align-items-stretch">
          <div class="col-xl-4 col-lg-6 col-md-12 d-flex mb-3">
            <div class="rounded border p-6 bg-white info-panel d-flex flex-column h-100 w-100">
              <h3 class="text-gray-800 fs-5">Расторжение</h3>
              <div class="text-gray-600 py-3 pb-6">
                Досрочное прекращение <br> действия страхового договора.
              </div>
              <router-link :to="{ name: 'Termination' }" type="button" class="btn-sm btn btn-light-success mt-auto align-self-start">
                Перейти
              </router-link>
            </div>
          </div>
          <!-- <div class="col-xl-4 col-lg-6 col-md-12 d-flex mb-3">
            <div class="rounded border p-6 bg-white info-panel d-flex flex-column h-100 w-100">
              <h3 class="text-gray-800 fs-5">Переоформление</h3>
              <div class="text-gray-600 py-3 pb-6">
                Переоформление страхового договора.
              </div>
              <router-link :to="{ name: 'Rewrite' }" type="button" class="btn-sm btn btn-light-success mt-auto align-self-start">
                Перейти
              </router-link>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <h6 class="ms-1 mb-5 mt-2 text-gray-700">ПОДФТ</h6>
        <div class="mb-3">
          <div class="rounded border p-6 bg-white info-panel">
            <h3 class="text-gray-800 fs-5">ПОДФТ</h3>
            <div class="text-gray-600 py-3 pb-6">
              Сервис проверки документов, при вводе ИИН/БИН и уникального кода.
            </div>
            <router-link :to="{ name: 'Podft' }" type="button" class="btn-sm btn btn-light-success">
              Перейти
            </router-link>&nbsp;
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MyAgreementsList from '@/components/Agreement/MyAgreementsList'

export default {
  name: 'IndexView',
  components: {MyAgreementsList},
  computed: {
    getUser() { return this.$store.state.user },
    agreements() { return this.$store.state.agreements }
  },
}
</script>

<style scoped>
</style>